// extracted by mini-css-extract-plugin
module.exports = {"popperContainer":"SelectCefrLevels_popperContainer__2qHE-"};